export const MAX_TRAINING_IMAGES = 10000
